module.exports = __webpack_public_path__ + "static/media/waves-1-tw.4782786c.svg";